"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineResponse20028ToJSON = exports.InlineResponse20028FromJSONTyped = exports.InlineResponse20028FromJSON = void 0;
function InlineResponse20028FromJSON(json) {
    return InlineResponse20028FromJSONTyped(json, false);
}
exports.InlineResponse20028FromJSON = InlineResponse20028FromJSON;
function InlineResponse20028FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'placeId': json['placeId'],
    };
}
exports.InlineResponse20028FromJSONTyped = InlineResponse20028FromJSONTyped;
function InlineResponse20028ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'placeId': value.placeId,
    };
}
exports.InlineResponse20028ToJSON = InlineResponse20028ToJSON;
